import { render } from "./FilterableDropdown.vue?vue&type=template&id=827ca624&ts=true"
import script from "./FilterableDropdown.vue?vue&type=script&lang=ts"
export * from "./FilterableDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__